<template>
  <div class="mod-config">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t('scheduleMode.availabilityModeConfig') }}</span>
      </div>
      <el-form :model="dataForm" label-width="180px">
        <el-form-item :label="$t('scheduleMode.currentAvailabilityMode')">
          <el-tag type="success" v-if="dataForm.currentMode">{{ modeName }}</el-tag>
          <el-tag type="info" v-else>{{ $t('common.loading') }}</el-tag>
        </el-form-item>
        
        <el-form-item :label="$t('scheduleMode.selectAvailabilityMode')">
          <el-radio-group v-model="dataForm.mode">
            <el-radio label="DAILY">{{ $t('scheduleMode.dailyMode') }}</el-radio>
            <el-radio label="THREE_DAY">{{ $t('scheduleMode.threeDayMode') }}</el-radio>
            <el-radio label="SEVEN_DAY">{{ $t('scheduleMode.sevenDayMode') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('common.saveConfig') }}</el-button>
          <el-button type="success" @click="initializeMode" :loading="initLoading">{{ $t('scheduleMode.initializeCurrentModeData') }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    
    <el-card class="box-card mode-description">
      <div slot="header" class="clearfix">
        <span>{{ $t('scheduleMode.modeDescription') }}</span>
      </div>
      <el-descriptions :column="1" border>
        <el-descriptions-item :label="$t('scheduleMode.attention')">
          {{ $t('scheduleMode.attentionContent') }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('scheduleMode.dailyMode')">
          {{ $t('scheduleMode.dailyModeContent') }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('scheduleMode.threeDayMode')">
          {{ $t('scheduleMode.threeDayModeContent') }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('scheduleMode.sevenDayMode')">
          {{ $t('scheduleMode.sevenDayModeContent') }}
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataForm: {
        currentMode: '',
        mode: 'DAILY' // 默认为每日模式
      },
      loading: false,
      initLoading: false
    }
  },
  computed: {
    modeName() {
      switch (this.dataForm.currentMode) {
        case 'DAILY':
          return this.$t('scheduleMode.dailyMode');
        case 'THREE_DAY':
          return this.$t('scheduleMode.threeDayMode');
        case 'SEVEN_DAY':
          return this.$t('scheduleMode.sevenDayMode');
        default:
          return this.$t('common.unknownMode');
      }
    }
  },
  created() {
    this.getCurrentMode();
  },
  methods: {
    // 获取当前系统使用的模式
    getCurrentMode() {
      this.$http({
        url: '/schedule/getCurrentMode',
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataForm.currentMode = data.mode;
          this.dataForm.mode = data.mode;
        } else {
          this.$message.error(data.msg || this.$t('scheduleMode.getCurrentModeFailed'));
        }
      }).catch(error => {
        console.error(this.$t('scheduleMode.getCurrentModeFailed'), error);
        this.$message.error(this.$t('scheduleMode.getCurrentModeRequestException'));
      });
    },
    
    // 提交表单，更改系统模式
    submitForm() {
      if (!this.dataForm.mode) {
        this.$message.warning(this.$t('scheduleMode.pleaseSelectAvailabilityMode'));
        return;
      }
      
      this.loading = true;
      console.log(this.$t('scheduleMode.submittedFormData'), this.dataForm);
      this.$http({
        url: '/schedule/setAvailabilityMode',
        method: 'post',
        params: {
          mode: this.dataForm.mode
        }
      }).then(({ data }) => {
        this.loading = false;
        if (data && data.code === 0) {
          this.$message.success(this.$t('scheduleMode.modeSettingSuccess'));
          this.getCurrentMode(); // 刷新当前模式
        } else {
          this.$message.error(data.msg || this.$t('scheduleMode.modeSettingFailed'));
        }
      }).catch(error => {
        this.loading = false;
        console.error(this.$t('scheduleMode.modeSettingFailed'), error);
        this.$message.error(this.$t('scheduleMode.modeSettingRequestException'));
      });
    },
    
    // 初始化当前模式的数据
    initializeMode() {
      this.$confirm(this.$t('scheduleMode.initializeConfirm'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        this.initLoading = true;
        this.$http({
          url: '/schedule/initializeCurrentMode',
          method: 'post'
        }).then(({ data }) => {
          this.initLoading = false;
          if (data && data.code === 0) {
            this.$message.success(this.$t('common.initializeSuccess'));
          } else {
            this.$message.error(data.msg || this.$t('common.initializeFailed'));
          }
        }).catch(error => {
          this.initLoading = false;
          console.error(this.$t('common.initializeFailed'), error);
          this.$message.error(this.$t('common.initializeRequestException'));
        });
      }).catch(() => {
        // 取消操作
      });
    }
  }
}
</script>

<style scoped>
.mod-config {
  padding: 20px;
}
.box-card {
  margin-bottom: 20px;
}
.mode-description >>> .el-descriptions-item__label {
  width: 180px;
}
</style> 